import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MainLayoutComponent } from '@vasta/client-core-layout';
import { UiDialogOutletComponent } from '@vasta/frontend-ui-overlay';

/**
 * The shell around every authenticated page. It is a route component rather
 * than a wrapper in `App` so the public schedule can render without the
 * header, the user menu or the dialog outlet.
 */
@Component({
  selector: 'app-authenticated-layout',
  imports: [RouterOutlet, MainLayoutComponent, UiDialogOutletComponent],
  template: `
    <cl-main-layout><router-outlet /></cl-main-layout>
    <ui-dialog-outlet />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticatedLayoutComponent {}
